import { render, staticRenderFns } from "./WyneBassadors.vue?vue&type=template&id=5912a3c7&scoped=true&"
import script from "./WyneBassadors.vue?vue&type=script&lang=js&"
export * from "./WyneBassadors.vue?vue&type=script&lang=js&"
import style0 from "./WyneBassadors.vue?vue&type=style&index=0&id=5912a3c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5912a3c7",
  null
  
)

export default component.exports